import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import DocuSeal from "components/DocuSeal/DocuSeal";
import CustomButton from "components/common/CustomButton/CustomButton";
import { IS_BROKER_PORTAL } from "config";
import { STERE_CHECKOUT_COMPLETED } from "constants/webhookEvents";
import { fireWebhookEvent } from "store/features/webhooksSlice";
import { clientSelector, quotesSelector } from "store/selectors/selectors";
import { RootState } from "store/store";
import { useT } from "translation";
import { sendMessageToClient } from "utils/utils";
import EsignSuccess from "./EsignSuccess";
import SuccessMessage from "./SuccessMessage";

const Confirmation = () => {
  const { t } = useT();
  const dispatch = useDispatch();
  const { submissionId, siaApplicationId } = useSelector(
    (state: RootState) => state.surveyJs
  );
  const { selectedQuotes } = useSelector(quotesSelector);
  const { applicantId } = useSelector((state: RootState) => state.client);
  const [showDocusealSuccess, setShowDocusealSuccess] = useState(false);
  const { clientUrl } = useSelector(clientSelector);

  useEffect(() => {
    if (!IS_BROKER_PORTAL) {
      dispatch(
        fireWebhookEvent({
          event_type: STERE_CHECKOUT_COMPLETED,
          metadata: {
            applicantId: applicantId,
            applicationId: siaApplicationId,
            submissionid: submissionId,
            selectedQuotes: selectedQuotes?.map((q) => {
              return {
                quote_id: q.id,
                premium: {
                  currency: q.premium?.currency,
                  premium_value: q.premium?.premium_value,
                  tax: q.premium?.tax,
                },
                insurer_name: q?.product_details?.insurer,
              };
            }),
            payment: {
              status: "Success",
              transactionId: sessionStorage.getItem("tId"),
            },
            policyId: sessionStorage.getItem("policyId"),
          },
        })
      );
      sessionStorage.removeItem("tId");
    }
  }, []);

  if (
    sessionStorage.getItem("template_slug") &&
    sessionStorage.getItem("template_slug") !== "undefined" &&
    !showDocusealSuccess
  ) {
    return (
      <DocuSeal
        onComplete={() => setShowDocusealSuccess(true)}
        templateSlug={sessionStorage.getItem("template_slug")}
      />
    );
  }

  if (showDocusealSuccess) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <EsignSuccess />
        <Box sx={{ textAlign: "right", m: "20px" }}>
          <CustomButton
            onClickCB={() => {
              sendMessageToClient({ type: "EXIT", details: {} }, clientUrl);
            }}
            btnText={t("EXIT")}
          />
        </Box>
      </Box>
    );
  }

  return <SuccessMessage message={t("PAYMENT_PAGE_SUCCESS_MESSAGE")} />;
};

export default Confirmation;
